import React, { useRef } from "react";
import { motion } from "framer-motion";

// Data
import apps from "../../../data/apps.json";

// Components
import Magnetic from "../../Common/Magnetic/Magnetic";

// SCSS
import "./DesktopIcons.scss";

const DesktopIcons = ({ setHoveredElement, openWindow }) => {
  // Drag Event
  const isDragging = useRef(false);

  // Click Event
  const handleTap = (app) => {
    if (app.isExternal) {
      window.open(app.path, "_blank", "noopener,noreferrer");
    } else {
      openWindow(app.id);
    }
  };

  return (
    // Icon Grid
    <div className="Icon__Grid">
      {apps
        .filter((app) => app.id !== "error")
        .map((app) => (
          // Wrapper
          <motion.div
            key={app.id}
            drag
            dragMomentum={false}
            dragElastic={0}
            onTap={() => {
              if (!isDragging.current) {
                handleTap(app);
              }
            }}
            onDragStart={() => (isDragging.current = true)}
            onDragEnd={() => {
              setTimeout(() => (isDragging.current = false), 100);
            }}
            className="Icon__Wrapper"
          >
            {/* Icon */}
            <Magnetic
              setHoveredElement={setHoveredElement}
              as="div"
              className="Icon"
            >
              <img
                src={app.icon}
                alt={app.name}
                className="Icon__Image"
                draggable="false"
              />
              {app.isBadge && <span className="Icon__Badge" />}
              <span className="Icon__Name">{app.name}</span>
            </Magnetic>
          </motion.div>
        ))}
    </div>
  );
};

export default DesktopIcons;
